// @module NXTurn.ShoppingExtensions.PDP
define('C3.ShoppingExtensions.CartPage.Wishlist.Rightside.ListControl.View'
,   [
        'c3_shoppingextensions_cartpage_wishlist_rightside_listcontrol.tpl',
         'Profile.Model',
       // 'SC.Configuration',
        'Utils',
        'Header.Menu.MyAccount.View',
        'Header.Menu.View',
        'C3.ShoppingExtensions.CartPage.Wishlist.Rightside.ListControl.Item.View',
        'Backbone.View',
        'ProductList.Item.Model',
        'Tracker',
        'ProductList.Model',
        'C3.ShoppingExtensions.CartPage.Wishlist.Rightside.ListControl.NewItem.View',
     //   'C3.ShoppingExtensions.CartPage.AddToWishlist.View'
    ]
, function (
        c3_shoppingextensions_cartpage_wishlist_rightside_listcontrol_tpl,
        ProfileModel,
        //Configuration,
        Utils,
        HeaderMenuMyAccountView,
        HeaderMenuView,
        ControlItemView,
        BackboneView,
        ProductListItemModel,
        Tracker,
        ProductListModel,
        ControlNewItemView,
    //    pdpWishlistView
)
{
    'use strict';

    // @class NXTurn.ShoppingExtensions.PDP.View @extends Backbone.View
    return Backbone.View.extend({

        template: c3_shoppingextensions_cartpage_wishlist_rightside_listcontrol_tpl

    ,   initialize: function (options) {
            this.product = options.product;
            this.collection = options.collection;
            this.application = options.application;
            this.moveOptions = options.moveOptions;
            this.countedClicks = options.countedClicks;
            this.options = options;

            this.parentView = options.parentView;

            this.product.on('change', this.render, this);
        }


    , render: function() {
        // if the control is currently visible then we remember that !
        this.is_visible = this.$('[data-type="productlist-control"]').is(':visible');

        BackboneView.prototype.render.apply(this);

        const self = this;

        self.collection.each(function(model) {
            const view = new ControlItemView({
                model: model,
                product: self.product,
                application: self.application,
                parentView: self,
                collection : self.collection
            });

            self.$('ul').prepend(view.render().el);
        });

        const new_product_list_model = this.getNewProductListModel();
        const new_item_view = new ControlNewItemView({
            model: new_product_list_model,
            application: self.application,
            parentView: self
        });

        //console.log(self.$('[data-type="new-item-container"]'))
        self.$('[data-type="new-item-container"]').html(new_item_view.render().el);
    },  

    getNewProductListModel: function() {
        return new ProductListModel();
    },   

     validateGiftCertificate: function validateGiftCertificate(line) {
        const line_option_email =
            line.get('options') &&
            line.get('options').findWhere({ cartOptionId: 'GIFTCERTRECIPIENTEMAIL' });

        if (line_option_email && !line_option_email.isValid(true)) {
            this.render(); // for unchecking the just checked checkbox
            this.showError(this.application.getErrorMessage('recipientEmailIsInvalid'));

            return false;
        }
        return true;
    },

    events: {

        },

   bindings: {
        },

    childViews: {
        },

    // Adds the product to the newly created list, renders the control and shows a confirmation msg
    addNewProductToList: function(newList) {
        return this.addItemToList(this.product, newList, true).then(() => {
            this.saveAndShowConfirmationMessage(
                this.$('.ul-product-lists [type="checkbox"]:checked').length > 1
                    ? Utils.translate('Good! You added this item to your product lists')
                    : Utils.translate('Good! You added this item to your product list')
            );
        });
    },

    // Add a new product list item into a product list
    addItemToList: function(line, productList, dontShowMessage) {
        const addItemPromise = jQuery.Deferred();
        if (line.isValid(true)) {
            const self = this;

            if (!productList.get('internalid')) {
                // this is a predefined list
                productList.save().done(function(data) {
                    const new_model = new ProductListModel(data);

                    self.application.ProductListModule.Utils.getProductLists().add(new_model, {
                        merge: true
                    });
                    self.doAddItemToList(line, new_model, dontShowMessage).then(() => {
                        addItemPromise.resolve();
                    });
                });
            } else {
                self.doAddItemToList(line, productList, dontShowMessage).then(() => {
                    addItemPromise.resolve();
                });
            }
        }
        return addItemPromise;
    },

    // This method is overridden in POS
    getNewItemData: function(line, productList) {
        const product_list_line = ProductListItemModel.createFromProduct(line);

        product_list_line.set('productList', {
            id: productList.get('internalid'),
            owner: productList.get('owner').id
        });

        return product_list_line;
    },

    // Adds the new item to the collection
    doAddItemToList: function(product, productList, dontShowMessage) {
        const self = this;
        const product_list_line_to_save = this.getNewItemData(product, productList);
        
        return product_list_line_to_save.save(null, {
            // Note this is lack of validation is require to not validate the JSON returned from the
            // services as it will lack the Model/Collection structure required to run the
            // validation. for example the list of options will be an array and not a collection
            // as the event handle that parse them didn't run yet
            validate: false,
            success: function(product_list_line_to_save_saved) {
                productList.get('items').add(product_list_line_to_save_saved);

                Tracker.getInstance().trackAddToWishlist(self.product);

                self.collection.trigger('changed');
                self.render();

                $('.wishlist-title h1').html('Item added!');

                var appendingChild = "<img class='heart' data-element='remove-from-favourites' src='/sca-b2c-2023/img/Blue Heart.svg'>";
                var parElement = $('.cartitem-'+self.product.get('internalid')+'')
                parElement.children().remove();
                parElement.append(appendingChild)
                //console.log(parElement)
            }
        });
    },

    // Check for predefined list before moving
    moveProductHandler: function(destination) {
        const self = this;

        if (!destination.get('internalid')) {
            // this is a predefined list
            return destination.save().then(function(data) {
                const new_product_list = new ProductListModel(data);

                self.application.ProductListModule.Utils.getProductLists().add(new_product_list, {
                    merge: true
                });
                return self.moveProduct(new_product_list);
            });
        }
        return self.moveProduct(destination);
    },

    // Moves the item to the destination list
    moveProduct: function(destination) {
        const self = this;
        const original_item = this.moveOptions.productListItem;
        const original_item_clone = original_item.clone();
        const details_view = this.moveOptions.parentView;

        original_item_clone.set('productList', {
            id: destination.get('internalid')
        });
        const moveProductResult = jQuery.Deferred();

        destination.get('items').create(original_item_clone, {
            validate: false,
            success: function(saved_model) {
                const app = details_view.application;
                const from_list = self.application.ProductListModule.Utils.getProductLists().findWhere(
                    { internalid: self.moveOptions.parentView.model.get('internalid') }
                );
                const to_list = self.application.ProductListModule.Utils.getProductLists().findWhere(
                    {
                        internalid: destination.get('internalid')
                    }
                );

                self.doMoveProduct(from_list, to_list, original_item, saved_model);

                details_view.model.get('items').remove(original_item);
                details_view.render();

                jQuery('.sc-flyout-bg').remove();

                app.getLayout().currentView.showConfirmationMessage(
                    Utils.translate(
                        '<div class="product-list-control-message">Good! You successfully moved the item from this to <a href="/wishlist/$(0)">$(1)</a></div>',
                        destination.get('internalid'),
                        destination.get('name')
                    )
                );
                moveProductResult.resolve();
            },
            wait: true
        });
        return moveProductResult;
    },

    // Adds the item clone to the destination list and removes the original from its list
    doMoveProduct: function(from, to, original_model, saved_model) {
        // if add not defined, create the collection
        if (to.get('items') instanceof Array) {
            to.set('items', new ProductListItemCollection());
        }

        // add the item to the application collection
        to.get('items').add(saved_model);

        from.get('items').remove(original_model);
        this.collection.trigger('changed');
    },

    // Gets the internal product id for a store item considering it could be a matrix child.
    getProductId: function(line) {
        if (line.getItemId) {
            return line.getItemId();
        }
        if (this.application.ProductListModule) {
            return this.application.ProductListModule.Utils.internalGetProductId(line);
        }
        return `${line.get('_id')}`;
    },

    // Determines if the control is visible
    isAvailable: function() {
        // if you want to disable the product list experience you instead can
        // return: ProfileModel.getInstance().get('isLoggedIn') === 'T';
        return true;
    },    


    // Renders a confirmation message storing message parameter and also stores the message
    saveAndShowConfirmationMessage: function(message) {
        this.confirm_message = message;

        this.showConfirmationMessage(this.confirm_message, true);
    },

    // Hides the confirmation message
    hideConfirmationMessage: function() {
        this.confirm_message = null;
        this.$('[data-confirm-message]').hide();
    },

        //@method getContext @return NXTurn.ShoppingExtensions.PDP.View.Context
    getContext: function getContext()
        {
            
            return {
             isMoving: this.mode === 'move',
            // @property {Boolean} showControl
            showControl: this.is_visible,
            // @property {Boolean} isEmpty
            isEmpty: this.collection.length === 0,
            // @property {Boolean} hasOneProductList
            hasOneProductList: this.collection.length === 1,
            // @property {Boolean} hasProductLists
            hasProductLists: this.collection.length > 0,
            // @property {Integer} productListLength
            productListLength: this.collection.length   
            };
        }
    });
});
